export default {
    auth: {
        title: "Log in to NCS",
        logIn: "Log in",
        logInAgain: "Log in again",
        logInFailed: "Login failed. Please try again.",
        customer: "Customer",
        customerNotFound: "Customer not found. Please try again.",
        sessionIdle: "Session Idle",
        sessionIdleExplanation: "Your NCS session has ended due to inactivity. Please log in again.",
    }
}
